import { useEffect, useState } from "react";

/** Gate below-the-fold content until after the first paint (improves mobile LCP). */
export default function useAfterFirstPaint() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const markReady = () => {
      if (!cancelled) {
        setReady(true);
      }
    };

    if (typeof window.requestIdleCallback === "function") {
      const idleId = window.requestIdleCallback(markReady, { timeout: 1200 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback(idleId);
      };
    }

    const frameId = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(markReady);
    });

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frameId);
    };
  }, []);

  return ready;
}
